import { forwardRef, useRef, useImperativeHandle, useCallback } from 'react';
import { noop, get } from 'lodash';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import ErrorMessage from 'components/Common/ErrorMessage';
import { useNodeContext } from 'contexts/NodeProvider';

const SelectWithController = forwardRef(
    (
        {
            control,
            name,
            defaultValue = '',
            label,
            placeholder,
            options = [],
            disabled,
            onChange = noop,
            required,
            registerRef = true,
            ...rest
        },
        ref
    ) => {
        const _ref = useRef();
        const { nodesRef } = useNodeContext();

        useImperativeHandle(ref, () => _ref.current);

        return (
            <div className="select-field-container">
                <Controller
                    control={control}
                    name={name}
                    defaultValue={defaultValue}
                    render={({
                        field: { value, onChange: handleChange, ref: rhfRef },
                        fieldState: { error },
                    }) => {
                        const onRefChange = useCallback((node) => {
                            if (registerRef) {
                                _ref.current = node;
                                rhfRef = _ref;
                                if (nodesRef) {
                                    nodesRef.current[name] = node;
                                }
                            }
                        }, []);
                        return (
                            <>
                                <Form.Group className="select-field">
                                    {label && (
                                        <Form.Label
                                            className="select-field-question"
                                            id={`label-question-select-${name}`}
                                        >
                                            {label}{' '}
                                            <span className="text-danger">
                                                {required ? ' *' : ' '}
                                            </span>
                                        </Form.Label>
                                    )}
                                    <Form.Select
                                        ref={onRefChange}
                                        data-testid={name}
                                        className="select-field-input"
                                        value={value ?? ''}
                                        aria-labelledby={`label-question-select-${name}`}
                                        disabled={disabled}
                                        onChange={(e) => {
                                            onChange(e.target.value);
                                            handleChange(e.target.value);
                                        }}
                                        {...rest}
                                    >
                                        <option value="" disabled>
                                            {placeholder ?? 'Select...'}
                                        </option>
                                        {options?.map(
                                            ({ label, value }, idx) => (
                                                <option
                                                    key={`option_${idx}`}
                                                    value={value}
                                                    className="select-field-label"
                                                >
                                                    {label}
                                                </option>
                                            )
                                        )}
                                    </Form.Select>
                                </Form.Group>{' '}
                                <ErrorMessage message={get(error, 'message')} />
                            </>
                        );
                    }}
                />
            </div>
        );
    }
);

export default SelectWithController;
